// queries/useDeleteImage.ts
"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { DELETE_IMAGE } from "api";

export const useDeleteImage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ file_name }: { file_name: string }) => {
      // Construct the request URL with the query parameter
      const endpoint = `${DELETE_IMAGE}?file_name=${encodeURIComponent(file_name)}`;
      const response = await fetch(endpoint, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          // Include any necessary authorization headers
        },
      });

      return await response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["images"] });
      console.log("Image deletion successful");
    },
    onError: (error) => {
      console.error("Error in useDeleteImage:", error.message);
    },
  });
};

export default useDeleteImage;
